"use strict";
const HTMLElementImpl = require("./HTMLElement-impl").implementation;

class HTMLSourceElementImpl extends HTMLElementImpl {}

module.exports = {
  implementation: HTMLSourceElementImpl
};
